import { type ApiRoleStrategy, ROLES } from "@pharmupp/p3-front-commons"

const adminBasePath = "/api/news/event"
const presidentBasePath = "/api/news/upp/event"

const presidentApiRoleConf = {
  endpoint: presidentBasePath,
  queryKey: ["news", "events", "list"],
}

export const apiRoleConf: ApiRoleStrategy = {
  [ROLES.ADMIN]: {
    endpoint: adminBasePath,
    queryKey: ["news", "events", "list"],
  },
  [ROLES.UPP_PRESIDENT]: presidentApiRoleConf,
  [ROLES.UPP_REPRESENTATIVE]: presidentApiRoleConf,
}
